<template>
    <div class="row bg-body p-2 mt-2 fixed-bottom d-flex justify-content-between align-items-center">
        <div class="col-4">
            <p class="text-muted small">Dressmaker  <span class="fw-bold">Pan0'Pli</span></p>
        </div>
        <div class="col-4 text-end">
            <p>&copy; {{ new Date().getFullYear()}}</p>
        </div>
    </div>
</template>